import Store from "./Store";
import axios from "axios";


export default class Authenticate {
  constructor() {
    this.store = new Store();
  }

  // セッションIDをセット
  setUid(uid) {
    this.store.set("uid", uid);
  }

  // セッションIDを取得
  getUid() {
    return this.store.get("uid");
  }
  // 会員区分をセット
  setShopping(shopping) {
    this.store.set("shopping", shopping);
  }

  // 会員区分を取得
  getShopping() {
    if (this.store.get("shopping") == '1') {
      return true;
    }
    else {
      return false;
    }
  }

  // セッションIDを削除
  removeUid() {
    this.store.remove("uid");
  }

  // セッションIDをセット
  setNoLoginUid(uid) {
    this.store.set("noLoginUid", uid);
  }

  // セッションIDを取得
  getNoLoginUid() {
    return this.store.get("noLoginUid");
  }

  // セッションIDを削除
  removeNoLoginUid() {
    this.store.remove("noLoginUid");
  }

  getMember() {
    this.store.get("member");
  }

  setMember(member) {
    this.store.set("member", member);
  }

  // トークン有無でログインを判断する
  isLogin() {
    return this.getUid() !== "";
  }

  isManager() {
    return this.store.get("isManager");
  }
  isManager_J() {
    return this.store.get("isManagerJ");
  }
  setManager(isManager) {
    return this.store.set("isManager", isManager);
  }
  setManager_J(isManager) {
    console.log('setisManagerJ')
    console.log(isManager)
    return this.store.set("isManagerJ", isManager);
  }
  loginName() {
    return this.store.get("loginName");
  }
  setLoginName(loginName) {
    return this.store.set("loginName", loginName);
  }

  // ログインフォームに復元する用の値
  getLoginInfo() {
    // storageのkeyは推測されないようにする
    return {
      no: this.store.get("a"),
      passwd: this.store.get("b"),
      omit: this.store.get("ab"),
    };
  }

  // ログイン成功時に保存する場合
  setLoginInfo(no, password, omit) {
    if (omit) {
      this.store.set("a", no);
      this.store.set("b", password);
      this.store.set("ab", omit);
    } else {
      this.clearLoginInfo();
    }
  }

  // ログインフォーム省略値をクリア
  clearLoginInfo() {
    this.store.remove("a");
    this.store.remove("b");
    this.store.remove("ab");
  }

  login(uid, member, shopping) {
    this.setUid(uid);
    this.setMember(member);
    this.setShopping(shopping);
    // Stateをログインで更新
    window.app.$store.commit("login");
    // ダッシュボードで遷移
    window.app.$router.push("/");
  }

  mobileAppLogin(uid) {
    this.setUid(uid);
    window.app.$store.commit("login");
  }

  logout() {
    // 該当HTMLを取得しにいく
    let requestParams = {};
    requestParams.uid = this.getUid();
    requestParams.className = "webMdlLogin";
    requestParams.actionName = "putLogout";
    axios
      .post(
        process.env.VUE_APP_API_BASE_URL,
        {
          post: JSON.stringify(requestParams)
        }
      )
      .finally(() => {
        this.removeUid();
        this.setManager(false);
        this.setManager(false);
        this.setMember("");
        this.setLoginName("");
        this.setShopping("");

        // Stateをログアウトで更新
        window.app.$store.commit("logout");
        window.app.$router.push("/login");
      });
  }
  logout2() {
    // 該当HTMLを取得しにいく
    let requestParams = {};
    requestParams.uid = this.getUid();
    requestParams.className = "webMdlLogin";
    requestParams.actionName = "putLogout";
    axios
      .post(
        process.env.VUE_APP_API_BASE_URL,
        {
          post: JSON.stringify(requestParams)
        }
      )
      .finally(() => {
        this.removeUid();
        this.setManager(false);
        this.setManager_J(false);
        this.setMember("");
        this.setLoginName("");
        this.setShopping("");

        // Stateをログアウトで更新
        window.app.$store.commit("logout");
      });
  }
}
